import {
  createApplicant,
  getApplicant,
  updateApplicant,
  updateApplicantAddresses,
  updateApplicantIncome,
  updateApplicantOutgoings,
} from '@/api/UK/applicants';
import {
  createApplication,
  finalizeApplication,
  getApplication,
  getCreditAmount,
  getDocumentFile,
  getDocuments,
  getProductTierProjection,
  selectProductTier,
  signDocuments,
} from '@/api/UK/credit';
import { getDirectDebit } from '@/api/UK/directDebit';
import { getBankAccountStatus } from '@/api/UK/me';
import {
  getBankAccount,
  getPayment,
  getPaymentById,
  initiateManualApproval,
  postManualPayment,
  setRepaymentDay,
  setupAccount,
  setupDirectDebit,
} from '@/api/UK/paymentProvider';

const UK = {
  applicants: {
    createApplicant,
    getApplicant,
    updateApplicant,
    updateApplicantAddresses,
    updateApplicantIncome,
    updateApplicantOutgoings,
  },
  credit: {
    createApplication,
    finalizeApplication,
    getApplication,
    getCreditAmount,
    getDocumentFile,
    getDocuments,
    getProductTierProjection,
    selectProductTier,
    signDocuments,
  },
  directDebit: { getDirectDebit },
  me: { getBankAccountStatus },
  paymentProvider: {
    getBankAccount,
    getPayment,
    getPaymentById,
    initiateManualApproval,
    postManualPayment,
    setRepaymentDay,
    setupAccount,
    setupDirectDebit,
  },
};

export default UK;
